import { SignUpRepository, SignUpOtpModel } from '@/AutoEnrollment/domain'
import { SignUpForm } from '@/AutoEnrollment/ui/hooks'
import { HttpModel } from '@/Shared/domain'

interface ISignUp {
  signUp: (data: SignUpForm) => Promise<HttpModel<SignUpOtpModel>>
}

export const SignUpContract = (signUpRepository: SignUpRepository): ISignUp => ({
  signUp: async (data: SignUpForm): Promise<HttpModel<SignUpOtpModel>> =>
    await signUpRepository.SignUp(data),
})
